// extracted by mini-css-extract-plugin
module.exports = {"container":"jg","hero":"kg","content":"lg","typeProd":"mg","notTransparent":"ng","sliderDots":"og","active":"pg"};